import styled, { css } from 'styled-components';

// Toast positioning + slide-up animation.
// Hidden state lives on the base styles (off-screen, opacity 0); $phase swaps
// in the visible/leaving variations so the CSS transition does the work.
export const UamToastRoot = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  width: 440px;
  max-width: calc(100vw - 48px);
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translate(-50%, 120%);
  opacity: 0;
  transition:
    transform 420ms cubic-bezier(0.34, 1.56, 0.64, 1),
    opacity 220ms ease-out;
  will-change: transform, opacity;

  ${({ $phase }) => $phase === 'visible' && css`
    transform: translate(-50%, 0);
    opacity: 1;
  `}

  ${({ $phase }) => $phase === 'leaving' && css`
    transform: translate(-50%, 30%);
    opacity: 0;
    transition:
      transform 200ms ease-in,
      opacity 160ms ease-in;
  `}
`;
